import Masonry from 'masonry-layout';

/*
===================================================================
Profiles
===================================================================
*/
export default (function () {
  let msnry;
  return {
    init() {
      this.buildLayout();
    },
    buildLayout() {
      const profileGrids = document.querySelectorAll('.profiles');
      if (profileGrids != null && profileGrids.length) {
        Array.from(profileGrids).forEach((profileGrid, i) => {
          msnry = new Masonry(profileGrid, {
            gutter: 20,
            transitionDuration: '0.3s',
            columnWidth: 33.333,
          });

          profileGrid.addEventListener('click', (e) => {
            if (e.target.matches('.js-expand-link')) {
              msnry.layout();
            }
          });
        });
      }
    },
  };
}());
